import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TpButtonModule } from '../tp-button/tp-button.module';
import { TpDropdownModule } from '../tp-dropdown/tp-dropdown.module';
import { TpEmailComposerModule } from '../tp-email-composer/tp-email-composer.module';
import { TpMergeTagChipsModule } from '../tp-merge-tag-chips/tp-merge-tag-chips.module';
import { TpTextBoxModule } from '../tp-text-box/tp-text-box.module';
import { TpToggleModule } from '../tp-toggle/tp-toggle.module';
import { AiContentGeneratorModule } from 'app/main/pm/crm/shared/ai-content-generator/ai-content-generator.module';
import { TpEmailContentFormComponent } from './tp-email-content-form.component';

@NgModule({
    declarations: [TpEmailContentFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatTooltipModule,
        TranslateModule,
        TpButtonModule,
        TpDropdownModule,
        TpTextBoxModule,
        TpEmailComposerModule,
        TpMergeTagChipsModule,
        TpToggleModule,
        AiContentGeneratorModule,
    ],
    exports: [TpEmailContentFormComponent],
})
export class TpEmailContentFormModule {}
